import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  padding: 0 30px;
`

const Content = styled.div`
  background: ${({ theme }) => theme.colors.background.grey};
  border-radius: 5px;
  padding: 15px;
  color: ${({ theme }) => theme.colors.font.darkFaded};
`

export const ResultHighlight: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  )
}
